<template>
    <div>
        <b-container>
            <h2 class="mb-4">{{ isEdit ? $t("productServices.edit_title") : $t("productServices.create_title") }}</h2>
            <b-card>
            <b-form @submit.prevent="handleSubmit" :validated="validated" novalidate>
                <!-- Company Name -->
                <b-form-group :label="$t('products.title')">
                    <b-form-select
                        v-model="form.product_id"
                        :options="ProductOptions"
                        required
                        class="form-control custom-select"
                        :invalid-feedback="formErrors.first('product_id')"

                    />
                </b-form-group>

                <b-form-group :label="$t('services.title')">
                    <b-form-select
                        v-model="form.service_id"
                        :options="ServiceOptions"
                        required
                        class="form-control "
                        :invalid-feedback="formErrors.first('service_id')"

                    />
                </b-form-group>

                <!-- Buttons -->
                <b-button type="submit" variant="primary" class="m-2">
                    {{ $t("common.save") }}
                </b-button>
                <b-button variant="secondary" @click="cancel" class="m-2">
                    {{ $t("common.cancel") }}
                </b-button>
            </b-form>
            </b-card>
        </b-container>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import Error from "@/Util/Error";

export default {

    data() {
        return {
            form: {
                product_id: "",
                service_id: "",
            },
            formErrors: new Error({}),
            validated: false,
            ProductOptions: [],
            ServiceOptions: [],
            isEdit: false,
            editId: null
        };
    },
    async mounted() {
        await this.products();
        await this.services();
        if (this.$route.params.id) {
            this.isEdit = true;
            this.editId = this.$route.params.id;
            await this.fetchProductService();
        }
    },
    methods: {

        async products() {
            try {
                const response = await request({
                    method: "get",
                    url: `/products`,
                });
                this.ProductOptions = response.data.map((item) => {
                    return {
                        value: item.id,
                        text: `${item.name}`,
                    };
                });
            } catch (error) {
                this.$bvToast.toast("Failed to fetch asset types", {
                    title: "Error",
                    variant: "danger",
                });
            }
        },
        async services() {
            try {
                const response = await request({
                    method: "get",
                    url: `/services`,
                });
                this.ServiceOptions = response.data.map((item) => {
                    return {
                        value: item.id,
                        text: `${item.title}`,
                    };
                });
            } catch (error) {
                this.$bvToast.toast("Failed to fetch asset types", {
                    title: "Error",
                    variant: "danger",
                });
            }
        },
        async fetchProductService() {
            try {
                const response = await request({
                    method: "get",
                    url: `/product-services/${this.editId}`,
                });
                this.form.product_id = response.data.product_id;
                this.form.service_id = response.data.service_id;
            } catch (error) {
                this.$bvToast.toast("Failed to fetch product service", {
                    title: "Error",
                    variant: "danger",
                });
            }
        },
        cancel() {
            this.$router.push({
                name: "AdminProductService",
            });
        },
        resetError() {
            this.formErrors = new Error({});
        },
        async handleSubmit() {
            this.validated = true;
            this.formErrors = new Error({});

            if (
                !this.form.product_id ||
                !this.form.service_id
            ) {
                if (!this.form.product_id) this.formErrors.errors.product_id = ['Product Id is required'];
                if (!this.form.service_id)
                    this.formErrors.errors.service_id = ['Service Id is required.'];
                return;
            }

            const fd = new FormData();
            fd.append("service_id", this.form.service_id);
            fd.append("product_id", this.form.product_id);

            try {
                if (this.isEdit) {
                    await request({
                        method: "put",
                        url: `/product-services/${this.editId}`,
                        data: fd,
                    });
                } else {
                    await request({
                        method: "post",
                        url: "/product-services",
                        data: fd,
                    });
                }
                this.$router.push({
                    name: "AdminProductService",
                });
            } catch (err) {
                if (err?.data?.errors) {
                    const norm = {};
                    for (const k in err.data.errors) {
                        norm[k] = err.data.errors[k];
                    }
                    this.errors = norm;
                }
            }
        },
    },
};
</script>
